import './assets/scss/reset.scss';
import './assets/scss/style.scss';
import Vue from 'vue';
import AOS from 'aos';

import Kakao from 'vue-kakao-sdk';
import App from './App.vue';
import router from './router';
import store from './store';

import './assets/fonts/Pretendard-1/pretendard-subset.css';
import './assets/fonts/Project-font/project-font.css';

import 'aos/dist/aos.css';

Vue.use(AOS);

const apiKey = 'f79c62f37801b4d76faa954b6071f049';
Vue.use(Kakao, { apiKey });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
